import { createRoute, lazyRouteComponent, stripSearchParams } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { parsePositiveInt, parseQuery } from './params.ts'
import { rootRoute } from './root.tsx'

// The gironi of a season: the main screen of the championship register. The season, the
// category open on the right and the delegation in scope are all typed search params (§4.4).

export interface LeagueSearch {
  readonly season: number | null
  readonly category: number | null
  /** A delegation's slug, or `NO_DELEGATION` for the gironi made by hand; `null` is all. */
  readonly delegation: string | null
}

export const DEFAULT_LEAGUE_SEARCH: LeagueSearch = {
  season: null,
  category: null,
  delegation: null,
}

/** The list with no filters: what "back to the list" means. */
export const leagueListLink = { to: '/leagues', search: DEFAULT_LEAGUE_SEARCH } as const

export const leaguesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/leagues',
  validateSearch: (search: Record<string, unknown>): LeagueSearch => ({
    season: parsePositiveInt(search.season),
    category: parsePositiveInt(search.category),
    delegation: parseQuery(search.delegation),
  }),
  search: {
    // Defaults leave the URL: a colleague receives /leagues?season=2026, not the full set.
    middlewares: [stripSearchParams(DEFAULT_LEAGUE_SEARCH)],
  },
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/leagues.tsx')),
})
